import React from "react";
import { OverlapChartBox } from "../../components/ReportTemplate/components/OverlapChartBox/OverlapChartBox";

export const renderOverlapChart = (data, GridBox) => {
  const key = data.label;

  return (
    <GridBox key={key} id={key}>
      <OverlapChartBox data={data} />
    </GridBox>
  );
};
